"use client";

import { useThemeMode } from "@/features/theme/theme-provider";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
    text: string;
    className?: string;
    iconClassName?: string;
    textClassName?: string;
    showIcon?: boolean;
}

function DarkEmptyIcon( { className }: { className?: string } ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="106"
            viewBox="0 0 120 106"
            fill="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M59.2227 3.3584C35.7979 3.3584 16.8027 22.4992 16.8027 46.1984C16.8027 69.8976 35.7979 89.0384 59.2227 89.0384C82.6475 89.0384 101.643 69.8976 101.643 46.1984C101.643 22.4992 82.5635 3.3584 59.2227 3.3584Z"
                fill="#333333"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M104.165 0C102.77 0 101.645 1.1256 101.645 2.52C101.645 3.9032 102.77 5.04 104.165 5.04C105.553 5.04 106.685 3.9032 106.685 2.52C106.685 1.1256 105.553 0 104.165 0Z"
                fill="white"
                fillOpacity="0.12"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.3227 13.4404C17.9283 13.4404 16.8027 14.566 16.8027 15.9604C16.8027 17.3436 17.9283 18.4804 19.3227 18.4804C20.7115 18.4804 21.8427 17.3436 21.8427 15.9604C21.8427 14.566 20.7115 13.4404 19.3227 13.4404Z"
                fill="white"
                fillOpacity="0.12"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.2 54.5996C1.8816 54.5996 0 56.4812 0 58.7996C0 61.118 1.8816 62.9996 4.2 62.9996C6.5184 62.9996 8.4 61.118 8.4 58.7996C8.4 56.4812 6.5184 54.5996 4.2 54.5996Z"
                fill="white"
                fillOpacity="0.12"
            />
            <g filter="url(#filter0_d_4622_84338)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.9859 22.6787C20.5299 22.6787 19.3203 23.8267 19.3203 25.3275V74.6803C19.3203 76.1307 20.5299 77.3347 21.9859 77.2787H97.2947C98.7507 77.2787 99.9603 76.0691 99.9603 74.6187V25.3275C99.9603 23.8827 98.8067 22.6787 97.2947 22.6787H21.9859Z"
                    fill="url(#paint0_linear_4622_84338)"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.3203 27.72H99.9603V23.7552C99.9603 22.2544 98.8067 21 97.2947 21H21.9859C20.5299 21 19.3203 22.1984 19.3203 23.7552V27.72Z"
                fill="url(#paint1_linear_4622_84338)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.6818 23.5186C22.217 23.5186 21.8418 23.8938 21.8418 24.3586C21.8418 24.8234 22.217 25.1986 22.6818 25.1986C23.1466 25.1986 23.5218 24.8234 23.5218 24.3586C23.5218 23.8938 23.1466 23.5186 22.6818 23.5186Z"
                fill="#F9FAFB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.2033 23.5186C24.7385 23.5186 24.3633 23.8938 24.3633 24.3586C24.3633 24.8234 24.7385 25.1986 25.2033 25.1986C25.6681 25.1986 26.0433 24.8234 26.0433 24.3586C26.0433 23.8938 25.6681 23.5186 25.2033 23.5186Z"
                fill="#F9FAFB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.7209 23.5186C27.2561 23.5186 26.8809 23.8938 26.8809 24.3586C26.8809 24.8234 27.2561 25.1986 27.7209 25.1986C28.1857 25.1986 28.5609 24.8234 28.5609 24.3586C28.5609 23.8938 28.1857 23.5186 27.7209 23.5186Z"
                fill="#F9FAFB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.4419 13.1936V1.0808C97.4419 0.476 96.8819 0 96.1819 0C95.4819 0 94.9219 0.476 94.9219 1.0808V13.1936C94.9219 13.7928 95.4819 14.28 96.1819 14.28C96.8819 14.28 97.4419 13.7928 97.4419 13.1936Z"
                fill="#5F5F5F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M106.086 25.1987H118.194C118.798 25.1987 119.28 24.6331 119.28 23.9331C119.28 23.2331 118.798 22.6787 118.194 22.6787H106.086C105.482 22.6787 105 23.2331 105 23.9331C105 24.6331 105.482 25.1987 106.086 25.1987Z"
                fill="#5F5F5F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M106.122 16.4747L114.763 7.79466C115.189 7.36346 115.189 6.62986 114.763 6.20426C114.337 5.77306 113.609 5.77306 113.178 6.20426L104.481 14.8843C104.056 15.3155 104.056 16.0491 104.481 16.4747C104.907 16.9059 105.635 16.9059 106.122 16.4747Z"
                fill="#5F5F5F"
            />
            <rect x="27.7109" y="36.501" width="6.57073" height="6.57073" rx="1.2963" fill="white" fillOpacity="0.12" />
            <rect
                x="27.6816"
                y="49.0371"
                width="6.57073"
                height="6.57073"
                rx="1.2963"
                fill="white"
                fillOpacity="0.12"
            />
            <rect
                x="27.6816"
                y="61.5723"
                width="6.57073"
                height="6.57073"
                rx="1.2963"
                fill="white"
                fillOpacity="0.12"
            />
            <rect x="37.1035" y="36.501" width="54.4992" height="6.57073" rx="1.2963" fill="white" fillOpacity="0.04" />
            <rect
                x="37.0762"
                y="49.0371"
                width="45.8407"
                height="6.57073"
                rx="1.2963"
                fill="white"
                fillOpacity="0.04"
            />
            <rect
                x="37.0762"
                y="61.5723"
                width="45.8407"
                height="6.57073"
                rx="1.2963"
                fill="white"
                fillOpacity="0.04"
            />
            <defs>
                <filter
                    id="filter0_d_4622_84338"
                    x="0.840311"
                    y="13.7187"
                    width="117.601"
                    height="91.5616"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="9.52" />
                    <feGaussianBlur stdDeviation="9.24" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.483592 0 0 0 0 0.486333 0 0 0 0 0.489596 0 0 0 0.27 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4622_84338" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4622_84338" result="shape" />
                </filter>
                <linearGradient
                    id="paint0_linear_4622_84338"
                    x1="17.927"
                    y1="21.4139"
                    x2="17.927"
                    y2="77.8681"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#18191B" />
                    <stop offset="0.9964" stopColor="#333333" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_4622_84338"
                    x1="76.6012"
                    y1="17.8816"
                    x2="74.3447"
                    y2="32.4695"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#757575" />
                    <stop offset="1" stopColor="#9C9C9C" />
                </linearGradient>
            </defs>
        </svg>
    );
}

function LightEmptyIcon( { className }: { className?: string } ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="106"
            viewBox="0 0 120 106"
            fill="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M59.223 3.3584C35.7982 3.3584 16.803 22.4992 16.803 46.1984C16.803 69.8976 35.7982 89.0384 59.223 89.0384C82.6478 89.0384 101.643 69.8976 101.643 46.1984C101.643 22.4992 82.5638 3.3584 59.223 3.3584Z"
                fill="#F4F4F5"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M104.164 0C102.769 0 101.644 1.1256 101.644 2.52C101.644 3.9032 102.769 5.04 104.164 5.04C105.553 5.04 106.684 3.9032 106.684 2.52C106.684 1.1256 105.553 0 104.164 0Z"
                fill="#1A1A1A"
                fillOpacity="0.12"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.323 13.4404C17.9286 13.4404 16.803 14.566 16.803 15.9604C16.803 17.3436 17.9286 18.4804 19.323 18.4804C20.7118 18.4804 21.843 17.3436 21.843 15.9604C21.843 14.566 20.7118 13.4404 19.323 13.4404Z"
                fill="#1A1A1A"
                fillOpacity="0.12"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.20024 54.5996C1.88184 54.5996 0.000244141 56.4812 0.000244141 58.7996C0.000244141 61.118 1.88184 62.9996 4.20024 62.9996C6.51864 62.9996 8.40024 61.118 8.40024 58.7996C8.40024 56.4812 6.51864 54.5996 4.20024 54.5996Z"
                fill="#1A1A1A"
                fillOpacity="0.12"
            />
            <g filter="url(#filter0_d_3789_49268)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.9866 22.6787C20.5306 22.6787 19.321 23.8267 19.321 25.3275V74.6803C19.321 76.1307 20.5306 77.3347 21.9866 77.2787H97.2954C98.7514 77.2787 99.961 76.0691 99.961 74.6187V25.3275C99.961 23.8827 98.8074 22.6787 97.2954 22.6787H21.9866Z"
                    fill="url(#paint0_linear_3789_49268)"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.321 27.72H99.961V23.7552C99.961 22.2544 98.8074 21 97.2954 21H21.9866C20.5306 21 19.321 22.1984 19.321 23.7552V27.72Z"
                fill="url(#paint1_linear_3789_49268)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.6811 23.5186C22.2163 23.5186 21.8411 23.8938 21.8411 24.3586C21.8411 24.8234 22.2163 25.1986 22.6811 25.1986C23.1459 25.1986 23.5211 24.8234 23.5211 24.3586C23.5211 23.8938 23.1459 23.5186 22.6811 23.5186Z"
                fill="#F9FAFB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.2035 23.5186C24.7387 23.5186 24.3635 23.8938 24.3635 24.3586C24.3635 24.8234 24.7387 25.1986 25.2035 25.1986C25.6683 25.1986 26.0435 24.8234 26.0435 24.3586C26.0435 23.8938 25.6683 23.5186 25.2035 23.5186Z"
                fill="#F9FAFB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.7216 23.5186C27.2568 23.5186 26.8816 23.8938 26.8816 24.3586C26.8816 24.8234 27.2568 25.1986 27.7216 25.1986C28.1864 25.1986 28.5616 24.8234 28.5616 24.3586C28.5616 23.8938 28.1864 23.5186 27.7216 23.5186Z"
                fill="#F9FAFB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.4419 13.1936V1.0808C97.4419 0.476 96.8819 0 96.1819 0C95.4819 0 94.9219 0.476 94.9219 1.0808V13.1936C94.9219 13.7928 95.4819 14.28 96.1819 14.28C96.8819 14.28 97.4419 13.7928 97.4419 13.1936Z"
                fill="#D0D0D4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M106.087 25.1987H118.194C118.799 25.1987 119.28 24.6331 119.28 23.9331C119.28 23.2331 118.799 22.6787 118.194 22.6787H106.087C105.482 22.6787 105 23.2331 105 23.9331C105 24.6331 105.482 25.1987 106.087 25.1987Z"
                fill="#D0D0D4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M106.122 16.4747L114.763 7.79466C115.188 7.36346 115.188 6.62986 114.763 6.20426C114.337 5.77306 113.609 5.77306 113.178 6.20426L104.481 14.8843C104.055 15.3155 104.055 16.0491 104.481 16.4747C104.907 16.9059 105.635 16.9059 106.122 16.4747Z"
                fill="#D0D0D4"
            />
            <rect
                x="27.7107"
                y="36.501"
                width="6.57073"
                height="6.57073"
                rx="1.2963"
                fill="#1A1A1A"
                fillOpacity="0.12"
            />
            <rect
                x="27.6812"
                y="49.0371"
                width="6.57073"
                height="6.57073"
                rx="1.2963"
                fill="#1A1A1A"
                fillOpacity="0.12"
            />
            <rect
                x="27.6812"
                y="61.5723"
                width="6.57073"
                height="6.57073"
                rx="1.2963"
                fill="#1A1A1A"
                fillOpacity="0.12"
            />
            <rect
                x="37.1033"
                y="36.501"
                width="54.4992"
                height="6.57073"
                rx="1.2963"
                fill="#1A1A1A"
                fillOpacity="0.04"
            />
            <rect
                x="37.0759"
                y="49.0371"
                width="45.8407"
                height="6.57073"
                rx="1.2963"
                fill="#1A1A1A"
                fillOpacity="0.04"
            />
            <rect
                x="37.0759"
                y="61.5723"
                width="45.8407"
                height="6.57073"
                rx="1.2963"
                fill="#1A1A1A"
                fillOpacity="0.04"
            />
            <defs>
                <filter
                    id="filter0_d_3789_49268"
                    x="0.841043"
                    y="13.7187"
                    width="117.6"
                    height="91.5616"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="9.52" />
                    <feGaussianBlur stdDeviation="9.24" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.483592 0 0 0 0 0.486333 0 0 0 0 0.489596 0 0 0 0.27 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3789_49268" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3789_49268" result="shape" />
                </filter>
                <linearGradient
                    id="paint0_linear_3789_49268"
                    x1="17.9278"
                    y1="21.4139"
                    x2="17.9278"
                    y2="77.8681"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FCFCFC" />
                    <stop offset="0.9964" stopColor="#F4F4F5" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_3789_49268"
                    x1="76.602"
                    y1="17.8816"
                    x2="74.3454"
                    y2="32.4695"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#BCC2CC" />
                    <stop offset="1" stopColor="#828A97" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default function EmptyState(
    { text, className, iconClassName, textClassName, showIcon = true }: EmptyStateProps,
) {
    const { themeMode } = useThemeMode();
    const iconClass = cn( "h-[106px] w-[120px]", iconClassName );

    return (
        <div className={cn( "h-[200px] flex flex-col items-center justify-center gap-3", className )}>
            {showIcon && ( themeMode === "dark"
                ? <DarkEmptyIcon className={iconClass} />
                : <LightEmptyIcon className={iconClass} /> )}
            <div className={cn( "text-sm text-center text-content-subtle font-medium", textClassName )}>{text}</div>
        </div>
    );
}
